(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.gp-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('gp-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('gp-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initContadores() {
    var els = document.querySelectorAll('[data-gp-count]');
    if (!els.length) return;
    function run(el) {
      var fin = parseFloat(el.getAttribute('data-gp-count'));
      var suf = el.getAttribute('data-gp-suffix') || '';
      if (isNaN(fin) || reduce) { el.textContent = (isNaN(fin) ? el.textContent : fin) + suf; return; }
      var t0 = null, dur = 1400;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = Math.round(fin * (1 - Math.pow(1 - p, 3)));
        el.textContent = v + suf;
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initGaleria() {
    var main = document.querySelector('[data-gp-main-img]');
    var thumbs = document.querySelectorAll('[data-gp-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        main.style.opacity = '0';
        var src = t.getAttribute('data-src');
        var alt = t.getAttribute('data-alt') || '';
        setTimeout(function () { main.src = src; main.alt = alt; main.style.opacity = '1'; }, 150);
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  function initCantidad() {
    var wrap = document.querySelector('[data-gp-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v += b.getAttribute('data-dir') === 'up' ? 1 : -1;
        input.value = Math.max(1, Math.min(99, v));
      });
    });
  }

  function initVariantes() {
    var json = document.querySelector('[data-gp-variants]');
    var form = document.querySelector('[data-gp-form]');
    if (!json || !form) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var fmt = function (c) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(c / 100); }
      catch (e) { return (c / 100).toFixed(2); }
    };
    function actualizar() {
      var sel = [];
      form.querySelectorAll('[data-gp-option]').forEach(function (fs) {
        var ck = fs.querySelector('input:checked');
        sel.push(ck ? ck.value : null);
      });
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      if (!v) return;
      idInput.value = v.id;
      document.querySelectorAll('[data-gp-price]').forEach(function (e) { e.textContent = fmt(v.price); });
      document.querySelectorAll('[data-gp-compare]').forEach(function (e) {
        e.textContent = v.compare_at_price && v.compare_at_price > v.price ? fmt(v.compare_at_price) : '';
      });
      document.querySelectorAll('[data-gp-submit]').forEach(function (b) { b.disabled = !v.available; });
      var label = document.querySelector('[data-gp-submit-label]');
      if (label) label.textContent = v.available ? label.getAttribute('data-on') : label.getAttribute('data-off');
      if (history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
    }
    form.querySelectorAll('[data-gp-option] input').forEach(function (i) { i.addEventListener('change', actualizar); });
  }

  function initSticky() {
    var bar = document.querySelector('[data-gp-sticky]');
    var target = document.querySelector('[data-gp-buybox]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var pasado = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', pasado);
      });
    }, { threshold: 0 });
    io.observe(target);
  }

  function init() {
    document.documentElement.classList.add('gp-js');
    initReveal(); initContadores(); initGaleria(); initCantidad(); initVariantes(); initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
